import React, { Component } from 'react'
import './SignUpMembersFinal.css'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import img_envelope from '../../utils/assets/images/envelope.png'
import PropTypes from 'prop-types'
import { fetchResendEmailMembersAction } from '../../actions/Authentification/SignUpMembers'

class SignUpMembersFinal extends Component {
  static propTypes = {
    userData: PropTypes.object.isRequired,
  }
  componentDidMount() {
    document.title = `Dashboard Membre | Succès Inscription`
  }

  render() {
    const { userData, resendEmailMembers, checkResendEmailMembers } = this.props

    return (
      <div className="aps-section-connexion-padding">
        <div className="aps-section-register-content aps-section-after-inscription">
          <h1 className="uk-text-center aps-section-after-register-title">
            On y est presque, juste une dernière étape !
          </h1>
          <div className="uk-text-center aps-section-after-register-envelop">
            <img className="aps-section-after-register-envelop-img" src={img_envelope} alt="logo" />
          </div>
          {resendEmailMembers.isLoading
            ?
              <div className="aps-spinner-component-loading">
                <div className="uk-spinner">
                  <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                     <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="8"></circle>
                  </svg>
                </div>
                <div className="aps-section-register-desc">chargement en cours</div>
              </div>
            :
              <div>
                {resendEmailMembers.isSuccess
                  ?
                    <div>
                      <p className="uk-text-center aps-section-after-register-desc">
                        Nous avons envoyé à nouveau un mail avec succès à <strong>
                        {userData.email}
                        </strong> <br /><br /> Veuillez vérifier votre boîte de réception et cliquez sur le lien dans le mail pour confirmer votre adresse.
                      </p>
                    </div>
                  :
                    <div>
                      {resendEmailMembers.isError
                        ?
                          <div>
                            <div className="uk-text-center uk-margin-xlarge">Une erreur s&apos;est produite lors du renvoie du mail ...</div>
                          </div>
                        :
                          <div>
                            <p className="uk-text-center aps-section-after-register-desc">
                              Nous avons envoyé un email à <strong>
                              {userData.email}
                              </strong> <br /><br /> Veuillez vérifier votre boîte de réception et cliquez sur le lien dans le mail pour confirmer votre adresse.
                            </p>
                          </div>
                      }
                    </div>
                }
              </div>
            }
            <br />
            <div className="aps-section-connexion-signup-btn-container-content uk-text-center">
              <Link className="aps-section-connexion-lost-password-link aps-section-connexion-signup-link-item"
                    to={{hash: '#'}}
                    onClick={() => checkResendEmailMembers(userData.email)}
              >
                Je n&apos;ai pas reçu le mail.<br /> Merci de me le renvoyer
              </Link>
            </div>
        </div>
      </div>
    )
  }
}
const  mapStateToProps = ({ resendEmailMembers }) => {
  return {
    resendEmailMembers,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    checkResendEmailMembers: (userEmail) => dispatch(fetchResendEmailMembersAction(userEmail)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUpMembersFinal)



// WEBPACK FOOTER //
// ./src/components/SignUpMembersFinal/index.js